import React from 'react';
import SolutionInstallmentExaminationPaymentWrapper from 'components/SolutionInstallmentExaminationPaymentWrapper/SolutionInstallmentExaminationPaymentWrapper';

export default function SolutionInstallmentExaminationPaymentContainer() {
    return (
        <SolutionInstallmentExaminationPaymentWrapper />
    )
}
